"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reReselect = _interopRequireDefault(require("re-reselect"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function mapArgsToCacheKey(state, key, tags, strictness) {
  return "".concat(key, " ").concat(tags.map(function (tag) {
    return tag;
  }).join(' '), " ").concat(strictness);
}

var _default = (0, _reReselect["default"])(function (state, key) {
  return state.data[key];
}, function (state, key, tags) {
  return tags;
}, function (state, key) {
  var strictness = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'equal';
  return strictness;
}, function (entities, tags, strictness) {
  if (!entities) return;
  var tagsLength = tags.length;
  return entities.filter(function (entity) {
    if (strictness === 'equal' && tagsLength != entity.__tags__.length) {
      return false;
    }

    return tags.every(function (tag) {
      return entity.__tags__.includes(tag);
    });
  });
})(mapArgsToCacheKey);

exports["default"] = _default;